module.exports = __webpack_public_path__ + "media/icons/player3-6a2c04e6.png";